<template>
	<div class="Home">
		<img @click="$router.push('/mine')" class="mine-btn" src="../assets/img/home/mine-btn.png" />
		<img @click="goUrl" class="xrg-btn" src="../assets/img/home/xrg.png" />
		<div class="control">
			<div class="btn-box">
				<div v-show="!preDownload" class="appoint-btn" @click="showLogin">{{accessToken?'已预约':'预约游戏'}}</div>
				<div v-show="preDownload" class="appoint-btn" @click="goDownload">预下载</div>
				<div class="lottery-btn" @click="$router.push('/lottery')">立即抽奖
					<span v-show="lotteryNum" class="badge">{{lotteryNum>99?'99+':lotteryNum}}</span>
				</div>

			</div>

			<div class="date-blank">
				<date :signDate="signDate" @sign="sign"></date>
			</div>
		</div>
	</div>
</template>

<script>
	import date from '@/components/home/date.vue'
	import utils from "@/assets/js/utils.js"
	export default {
		name: "home",
		components: {
			date
		},
		data() {
			return {
				signDate: [],
				signToday: false,
				lotteryNum: 0,
				now: new Date().getTime(),
				downloadTime : new Date('2022/2/9 18:00').getTime(),
				showed: false,
			};
		},
		created() {
			if (this.accessToken) {
				this.init()
			}
			setInterval(() => {
				this.now = new Date().getTime()
				
				if(!this.showed){
					this.goDownload()
				}
			}, 1000)

		},
		computed: {
			accessToken() {
				return this.$store.getters.accessToken
			},
			preDownload() {
				if (this.now < this.downloadTime) {
					return false
				} else {
					return true
				}
			}
		},
		watch: {
			accessToken(cv) {
				if (cv) {
					this.init()
				}
				//localStorage.setItem('accessToken', cv)
			}
		},
		methods: {
			async init() {
				let res = await this.$store.dispatch('getSignInDay', {
					dateRange: '2022-01-11,2022-6-02'
				})
				if (this.$Api.ok(res)) {
					this.signDate = res[0].data.data
				}
				this.getLotteryLeftNum()
			},

			showLogin() {
				if (this.accessToken) {
					return this.$Toast.show('已预约')
				}
				this.$Login.show(() => {
					//this.init()
				})
			},

			async getLotteryLeftNum() {
				let res = await this.$store.dispatch('getLotteryLeftNum', {})
				if (this.$Api.ok(res)) {
					this.lotteryNum = res[0].data.data.lotteryNum
				}
			},
			async sign() {
				// this.$Confirm.show('2月9日可预下载', async () => {
				if (this.signToday) {
					return this.$Toast.show('今日已签到，无法再签')
				}
				if (!this.accessToken) {
					return this.$Login.show(() => {
						//this.init()
					})
				}
				let res = await this.$store.dispatch('setSign', {})
				if (this.$Api.ok(res)) {
					this.signToday = true
					this.$Toast.show({
						content: '签到成功',
					})
					this.init()
				} else if (this.$Api.find(res, [1310])) {
					return this.signToday = true
					//this.$Toast.show('今日已签到，无法再签')
				}
				// },'确认签到')

			},
			getQueryString(name) {
				var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
				var r = window.location.search.substr(1).match(reg);
				if (r != null) {
					return unescape(r[2]);
				}
				return null;
			},
			goUrl() {
				if (this.getQueryString('type') == 99) {
					window.location.href = '../index.html?type=99&version=1'
				} else {
					window.location.href = '../index.html?version=1'
				}
			},
			goDownload() {
				if (this.now > this.downloadTime) {
					this.showed = true
					
					this.$Confirm.show('手游正式包已经开始下载啦！', () => {
						let src =
							'https://cdndownload.yofijoy.com/wodemenpai/guanfanganzhuo/wodemenpai_zs_gf_v1.1.3_202202071748.apk'
						utils.copy(src)
						this.$Toast.show('下载链接已复制，可前往浏览器下载')
						utils.download(src, '我的门派-预下载')
					},'去下载')
				}
			}
		},
	};
</script>
<style scoped>
	.Home {
		width: 100%;
		height: 100%;
		background: url(../assets/img/home/home-bg.jpg);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		overflow-y: scroll;
	}

	.mine-btn {
		min-width: 60px;
		height: 60px;
		float: right;
		margin-top: 50px;
		margin-right: 10px;
	}

	.xrg-btn {
		min-width: 60px;
		height: 60px;
		float: right;
		margin-top: 50px;
		margin-right: 10px;
	}

	.control {
		margin-top: 340px;
		width: 100%;
	}

	.btn-box {
		display: flex;
		justify-content: space-around;
		width: 100%;
	}


	.date-blank {
		width: 100%;
	}

	.badge {
		padding: 4px;
		border-radius: 50px;
		display: inline-block;
		height: 10px;
		height: 10px;
		line-height: 12px;
		vertical-align: middle;
		color: #ffffff;
		background-color: red;
	}

	.appoint-btn {

		width: 100%;
		height: 40px;
		background: url(../assets/img/home/appoint-btn.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		text-align: center;
		line-height: 40px;
		color: #8d6045;

	}

	.lottery-btn {
		width: 100%;
		height: 40px;
		background: url(../assets/img/mine/btn-bg.png);
		background-position: center center;
		background-repeat: no-repeat;
		background-size: contain;
		text-align: center;
		line-height: 40px;
		color: #8d6045;
	}
</style>
